import './investor-email-unique';
import './password-complexity';
import './phone-number';
import './valid-sin'